import { TextButton as TPATextButton, TextButtonPriority } from '@wix/wix-ui-tpa/cssVars';
import React from 'react';
import { DATA_HOOKS } from '../../constants';
import { useTranslation } from '../../contexts/translation-context';
import { classes } from './ricos-viewer.st.css';
export const ToggleTruncateButtonWUT = _ref => {
  let {
    isTruncated,
    onClick
  } = _ref;
  const {
    t
  } = useTranslation();
  const buttonText = isTruncated ? t('field.rich-text.read-more-button.label') : t('field.rich-text.read-less-button.label');
  const dataHook = isTruncated ? DATA_HOOKS.TOGGLE_TRUNCATE_BUTTON_READ_MORE : DATA_HOOKS.TOGGLE_TRUNCATE_BUTTON_READ_LESS;
  return /*#__PURE__*/React.createElement(TPATextButton, {
    priority: TextButtonPriority.primary,
    onClick: onClick,
    className: classes.truncateToggle,
    "data-hook": dataHook
  }, buttonText);
};
//# sourceMappingURL=toggle-truncate-button-wut.js.map